import React from "react";
import { NavLink } from "react-router-dom";
import Button from "../../button/button";

// import "./NavigationItems.css";
import "./pageItems.css";

function PageContainer(props) {
  return (
    <>
      <div id="page-container" className="page">
        <h1>{props.title}</h1>
        <hr />
        {props.isAuth && (
          <Button design="raised" mode="accent" onClick={props.onAddItem}>
            New project
          </Button>
        )}
        <ul id="page-items">{props.children}</ul>
      </div>
    </>
  );
}

export default PageContainer;
